import { render, staticRenderFns } from "./HeaderMoreInfo.vue?vue&type=template&id=aa600df4&"
import script from "./HeaderMoreInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMoreInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports